<template>
  <div class="footer">
    <ul class="menu">
      <li :class="['menu-item', { 'menu-item-open': openIndex === index }]" v-for="(menu, index) in menus" :key="index">
        <div class="menu-item-text" @click="open(menu, index)">
          <div class="title">{{menu.name}}</div>
          <div class="menu-item-icon" v-for="(icon, iconIndex) in menu.icon" :key="iconIndex" @click="isShow = iconIndex === 0">
            <img :src="icon" alt="">
          </div>
          <div class="menu-item-arrow" v-if="menu.children"></div>
        </div>
        <ul class="menu-item-sub" v-for="(child, cIndex) in menu.children" :key="cIndex" @click="jump(child.path)">
          <li class="menu-item-text" >
            {{child.name}}
          </li>
        </ul>
      </li>
    </ul>
    <div class="footer-desc">
      <div class="footer-desc-item" v-for="(item, index) in descList" :key="index">
        <div class="footer-desc-text" v-for="(text, textIndex) in item" :key="textIndex" @click="textLinkClick(index,textIndex)">{{text}}</div>
      </div>
    </div>
    <div class="footer-btn" @click="hanldeScrollTop">回到顶部</div>
    <Qrcode v-model="isShow"></Qrcode>
  </div>
</template>

<script>
import Qrcode from "@/components/Qrcode.vue";
export default {
  name: 'layout-footer',
  components: {
    Qrcode
  },
  data () {
    return {
      isShow: false,
      menus: [
        { name: '关注我们', path: '', icon: [
          require('@/assets/images/icon_wechat.png'),
          // require('@/assets/images/icon_weibo.png'),
        ] },
        { name: '走进博智林', path: '', children: [
          { name: '公司简介', path: '/introduce' },
          { name: '合作与成果', path: '/achievement' },
        ] },
        { name: '产品及服务', path: '', children: [
          { name: '建筑机器人', path: '/robot-list' },
          { name: '数字科技', path: '/digi-tech' },
          { name: '新型建筑工业化', path: '/new-build' },
          { name: '智慧施工', path: '/build' },
          { name: '下载中心', path: '/download' },
        ] },
        { name: '新闻资讯', path: '', children: [
          { name: '公司新闻', path: '/news' },
          { name: '媒体报道', path: '/medias' },
        ] },
        { name: '加入我们', path: '', children: [
          { name: '人才招募', path: '/recruit' },
          { name: '员工生活', path: '/life' },
        ] },
        // { name: '合作交流', path: '', children: [
        //   { name: '对外合作', path: '/cooperation' },
        // ] },
      ],
      openIndex: -1,
      descList: [
        ['与博智林取得联系', '电话：400 - 988 2007', '电子邮箱：bzlbranding@countrygarden.com.cn', '地址：佛山市顺德区北滘镇南平路博智林机器人'],
        ['Copyright 1998 - 2021 Bright Dream Robotics.', 'All Rights Reserved', '粤公网安备44060602001323号','粤ICP备18152478号'],

      ]
    };
  },
  methods: {
    textLinkClick(index,textIndex){
      console.log('index>>',index);
      if(textIndex===2 && index ===1){
        window.open("http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44060602001323");
      }
      if(textIndex===3 && index ===1){
        window.open(" https://beian.miit.gov.cn/");
      }
    },
    open ({ children = [], path }, index) {
      if (children.length > 0) {
        this.openIndex = index === this.openIndex ? -1 : index;
      } else {
        this.jump(path);
      }
    },
    hanldeScrollTop () {
      const distance = document.body.scrollTop || document.documentElement.scrollTop;
      const duration = 300;
      const startTime = new Date().getTime();
      let handler = null;

      const scroll = () => {
        const time = new Date().getTime() - startTime;
        document.documentElement.scrollTop = document.body.scrollTop = distance - time * (distance / duration);
        handler = requestAnimationFrame(scroll);
        if (time > duration) {
          cancelAnimationFrame(handler)
        }
      }
      handler = requestAnimationFrame(scroll);
    },
    jump (path) {
      if (path && path !== this.$route.path && path !== this.$route.fullPath) {
        this.openIndex = -1;
        this.$router.push(path);
      }
    }
  }
};
</script>
<style lang='less' scoped>
.menu {
  &-item {
    &-text {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 104px;
      padding: 0 55px 0 48px;
      font-size: 32px;
      font-weight: 400;
      color: #666;
      .title {
        margin-right: 82px;
      }
    }
    &-arrow {
      width: 36px;
      height: 36px;
      margin-left: auto;
      background: url("~@/assets/images/icon_arrow.png") no-repeat;
      background-size: 100% 100%;
      transform: rotate(0deg);
      transition: transform 0.3s ease-out;
    }
    &-sub {
      visibility: hidden;
      .menu-item-text {
        font-size: 28px;
        height: 0;
        opacity: 0;
        transition: all 0.3s ease-out;
      }
    }
    &-icon {
      width: 48px;
      height: 48px;
      margin-right: 56px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    &-open {
      .menu-item-arrow {
        transform: rotate(180deg);
      }
      .menu-item-sub {
        visibility: visible;
        .menu-item-text {
          opacity: 1;
          height: 88px;
        }
      }
    }
  }
}
.footer {
  padding-top: 64px;
  background-color: #F9F9F9;
  &-desc {
    padding: 0 48px 16px 48px;
    &-item {
      padding: 48px 0;
      font-size: 22px;
      font-weight: 400;
      line-height: 36px;
      color: #999999;
      &:not(:last-child) {
        border-bottom: 1px solid #D8609E;
      }
    }
    &-text {
      margin-bottom: 12px;
    }
  }
  &-btn {
    height: 100px;
    line-height: 100px;
    text-align: center;
    font-size: 32px;
    font-weight: 400;
    color: #333333;
    background-color: #F0F0F0;
  }
}
</style>
